"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogLevel = void 0;
let LogLevel;
exports.LogLevel = LogLevel;

(function (LogLevel) {
  LogLevel["Debug"] = "DEBUG";
  LogLevel["Info"] = "INFO";
  LogLevel["Warn"] = "WARN";
  LogLevel["Error"] = "ERROR";
  LogLevel["Fatal"] = "FATAL";
})(LogLevel || (exports.LogLevel = LogLevel = {}));
//# sourceMappingURL=contracts.js.map